import { Box, Grid, styled } from '@material-ui/core';

export const Container = styled(Box)({
  display: 'flex',
  padding: 12,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 12,
  borderRadius: 16,
  border: `1px solid #EEF0F2`
});

export const TitleContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  padding: '4px 0px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 4,
  flex: '1 0 0',
  alignSelf: 'stretch'
});

export const ManufacturerContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 4,
  width: '100%',
  padding: '6px 0px',
  alignSelf: 'stretch'
});

export const PriceContainer = styled(Grid)({
  width: '100%',
  padding: '4px 0px',
  justifyContent: 'space-between',
  alignItems: 'center',

  '& button': {
    borderRadius: 120
  }
});

export const PriceItem = styled(Grid)({
  height: 40,
  display: 'flex',
  alignItems: 'center'
});
